import { WifiStrength4AlertIcon } from './WifiStrength4AlertIcon';

/**
 * author: Simran
 * id B37308A1-15BE-4F23-82F4-B360C8BA63C1
 * name wifi-strength-4-alert
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wifi-strength-4-alert.svg
 * tags
 * - Alert / Error 
 */
export const WifiStrength4WarningIcon = WifiStrength4AlertIcon;
export default WifiStrength4WarningIcon